/* ica-whatsapp-qualifier.js — P10 WhatsApp Lead Qualifier (T1 #8)

   State machine: closed → picker → answer → form → handoff → closed.
   Vanilla JS, no jQuery. Registered as the <whatsapp-qualifier> custom element.

   Event firing goes through window.icaEvents.fire(...) (ica-events.js), which
   owns the Klaviyo identify+track. CRITICAL (US-3): on form submit we fire
   'quote_qualifier_submitted' (identify happens inside icaEvents because the
   payload carries contact_email) BEFORE building/opening the WhatsApp tab — the
   lead is captured even if the user never taps Continue. On panel close with a
   partial flow + contact captured but no handoff reached, we fire
   'quote_qualifier_abandoned' with partial properties. All event firing is
   wrapped fail-silent so the UI flow is never blocked.
*/
(function () {
  'use strict';

  var ICONS = {
    quote: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M9 13h6M9 17h4"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 6v6l4 2"/><circle cx="12" cy="12" r="9"/></svg>',
    colors: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="13.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="10.5" r="2.5"/><circle cx="8.5" cy="7.5" r="2.5"/><circle cx="6.5" cy="12.5" r="2.5"/><path d="M12 22a4 4 0 0 0 4-4c0-1.5-1-2-2-3-2-1.5-6-1.5-6 2a5 5 0 0 0 4 5z"/></svg>',
    engineer: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.7V18a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 .1 2.2 2 2 0 0 1 2.1 0h3.3a2 2 0 0 1 2 1.7c.1 1 .4 1.9.7 2.8a2 2 0 0 1-.5 2.1L6.3 7.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.8.6 2.8.7a2 2 0 0 1 1.7 2z"/></svg>',
    payment: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>',
    other: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.5-3 4"/><path d="M12 17h.01"/></svg>',
    generic: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>'
  };

  var FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

  function fireEvent(type, payload) {
    try {
      if (window.icaEvents && typeof window.icaEvents.fire === 'function') {
        window.icaEvents.fire(type, payload || {});
      }
    } catch (e) { /* fail silent — never block the UI flow */ }
  }

  function rand4() {
    var alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
    var out = '';
    for (var i = 0; i < 4; i++) {
      out += alphabet.charAt(Math.floor(Math.random() * alphabet.length));
    }
    return out;
  }

  function refId() {
    var d = new Date();
    var y = d.getFullYear();
    var m = ('0' + (d.getMonth() + 1)).slice(-2);
    var day = ('0' + d.getDate()).slice(-2);
    return 'ICA-Q-' + y + '-' + m + '-' + day + '-' + rand4();
  }

  function looksLikeEmail(v) { return /.+@.+\..+/.test(v); }
  function looksLikePhone(v) { return /[0-9]{6,}/.test((v || '').replace(/[\s()\-+]/g, '')); }

  function WhatsAppQualifier(root) {
    this.root = root;
    this.panel = root.querySelector('.wa-panel');
    this.backdrop = root.querySelector('[data-wa-backdrop]');
    this.fab = root.querySelector('[data-wa-open]');
    this.body = root.querySelector('[data-wa-body]');
    this.titleEl = root.querySelector('[data-wa-title]');
    this.subtitleEl = root.querySelector('[data-wa-subtitle-text]');
    this.progress = root.querySelector('[data-wa-progress]');
    this.progressLabel = root.querySelector('[data-wa-progress-label]');
    this.segs = Array.prototype.slice.call(root.querySelectorAll('.wa-progress__seg'));
    this.views = {};
    Array.prototype.slice.call(root.querySelectorAll('[data-wa-view]')).forEach(function (v) {
      this.views[v.getAttribute('data-wa-view')] = v;
    }, this);
    this.form = root.querySelector('[data-wa-form]');

    this.state = 'closed';
    this.submitted = false;     // form successfully submitted (Submitted event fired)
    this.handedOff = false;     // user tapped Continue on WhatsApp
    this.abandonFired = false;
    this.reference = null;
    this.lastFocused = null;
    this.currentFaqIndex = null;

    // parse data islands
    this.faqs = this.parseJson('[data-wa-faqs]') || [];
    this.routes = this.parseJson('[data-wa-routes]') || {};
    this.businessName = root.getAttribute('data-wa-business-name') || 'Industrial Coatings Africa';
    this.dwellMs = parseInt(root.getAttribute('data-wa-dwell-ms'), 10);
    if (isNaN(this.dwellMs)) this.dwellMs = 7000;
    this.pdpProduct = root.getAttribute('data-wa-pdp-product') || '';
    this.pdpSubstrate = root.getAttribute('data-wa-pdp-substrate') || '';
    this.activeRegion = (this.routes && this.routes.active) || root.getAttribute('data-wa-region-code') || 'GH';

    this.renderIcons();
    this.bind();
    this.prefill();
    this.scheduleReveal();
    this.watchPdpSticky();
  }

  // B4 — PDP sticky-bar coexistence. On PDPs the mobile/tablet sticky CTA bar
  // (#ica-pdp-sticky) overlaps the FAB at the bottom-right. We mirror the sticky
  // bar's active state onto the FAB via .wa-fab--lifted so CSS can lift it above
  // the bar. The CSS also keys on body.ica-pdp-sticky-on (set by ica-pdp.js's
  // own IntersectionObserver) — this JS is a load-order-independent backstop.
  //
  // A MutationObserver on the sticky bar's class attribute is used rather than an
  // IntersectionObserver: the sticky bar is position:fixed and toggles between
  // display:none / flex via the .is-active class, which an IntersectionObserver
  // can't read reliably, whereas the class flip IS the visibility signal. Fully
  // null-guarded: pages with no sticky bar (every non-PDP page) bail immediately.
  WhatsAppQualifier.prototype.watchPdpSticky = function () {
    var sticky = document.getElementById('ica-pdp-sticky');
    if (!sticky || !this.fab || typeof MutationObserver === 'undefined') return;
    var fab = this.fab;
    var sync = function () {
      fab.classList.toggle('wa-fab--lifted', sticky.classList.contains('is-active'));
    };
    sync(); // initial state (sticky may already be active on a deep-link/scroll restore)
    try {
      var mo = new MutationObserver(sync);
      mo.observe(sticky, { attributes: true, attributeFilter: ['class'] });
    } catch (e) { /* fail silent — FAB simply won't lift; CSS body-hook still covers it */ }
  };

  WhatsAppQualifier.prototype.parseJson = function (sel) {
    var el = this.root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };

  WhatsAppQualifier.prototype.renderIcons = function () {
    Array.prototype.slice.call(this.root.querySelectorAll('[data-wa-icon-slot]')).forEach(function (slot) {
      var key = slot.parentNode.getAttribute('data-faq-icon') || 'generic';
      slot.innerHTML = ICONS[key] || ICONS.generic;
    });
  };

  WhatsAppQualifier.prototype.scheduleReveal = function () {
    var self = this;
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      this.fab.classList.add('is-revealed');
      return;
    }
    if (this.dwellMs <= 0) {
      this.fab.classList.add('is-revealed');
      return;
    }
    window.setTimeout(function () { self.fab.classList.add('is-revealed'); }, this.dwellMs);
  };

  WhatsAppQualifier.prototype.bind = function () {
    var self = this;
    this.fab.addEventListener('click', function () { self.open(); });
    Array.prototype.slice.call(this.root.querySelectorAll('[data-wa-close]')).forEach(function (b) {
      b.addEventListener('click', function () { self.close(); });
    });
    if (this.backdrop) this.backdrop.addEventListener('click', function () { self.close(); });

    // FAQ picks
    Array.prototype.slice.call(this.root.querySelectorAll('[data-wa-faq]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-faq-index'), 10);
        if (btn.hasAttribute('data-wa-jump-form')) {
          self.go('form');
        } else {
          self.showAnswer(idx);
        }
      });
    });

    var backPicker = this.root.querySelector('[data-wa-back-picker]');
    if (backPicker) backPicker.addEventListener('click', function () { self.go('picker'); });
    var backForm = this.root.querySelector('[data-wa-back-from-form]');
    if (backForm) backForm.addEventListener('click', function () { self.go('picker'); });

    var answered = this.root.querySelector('[data-wa-answered]');
    if (answered) answered.addEventListener('click', function () { self.close(); });
    var needHelp = this.root.querySelector('[data-wa-need-help]');
    if (needHelp) needHelp.addEventListener('click', function () { self.go('form'); });

    if (this.form) {
      this.form.addEventListener('submit', function (e) { e.preventDefault(); self.handleSubmit(); });
    }

    // region override re-routes the handoff number live
    var regionSel = this.root.querySelector('[data-wa-region-select]');
    if (regionSel) {
      regionSel.addEventListener('change', function () {
        self.activeRegion = regionSel.value || 'GH';
      });
    }

    var cont = this.root.querySelector('[data-wa-continue]');
    if (cont) cont.addEventListener('click', function () { self.handedOff = true; });

    // ESC + focus trap
    this.root.addEventListener('keydown', function (e) {
      if (self.state === 'closed') return;
      if (e.key === 'Escape') { e.preventDefault(); self.close(); return; }
      if (e.key === 'Tab') self.trapFocus(e);
    });
  };

  WhatsAppQualifier.prototype.prefill = function () {
    // region select defaults to detected market
    var regionSel = this.root.querySelector('[data-wa-region-select]');
    if (regionSel) {
      var opt = regionSel.querySelector('option[value="' + this.activeRegion + '"]');
      if (opt) regionSel.value = this.activeRegion;
    }
    // PDP auto-fill: substrate + product (US-2)
    if (this.pdpSubstrate) {
      var subSel = this.root.querySelector('[data-wa-input="substrate"]');
      if (subSel) {
        this.selectByText(subSel, this.pdpSubstrate);
        var subField = this.root.querySelector('[data-wa-substrate-field]');
        if (subField) subField.classList.add('is-prefilled');
      }
    }
    if (this.pdpProduct) {
      var prodSel = this.root.querySelector('[data-wa-input="product"]');
      if (prodSel) {
        var matched = this.selectByText(prodSel, this.pdpProduct);
        if (!matched) {
          var o = document.createElement('option');
          o.value = this.pdpProduct; o.textContent = this.pdpProduct; o.selected = true;
          prodSel.insertBefore(o, prodSel.firstChild);
        }
        var prodField = this.root.querySelector('[data-wa-product-field]');
        if (prodField) prodField.classList.add('is-prefilled');
      }
    }
  };

  WhatsAppQualifier.prototype.selectByText = function (sel, text) {
    var opts = Array.prototype.slice.call(sel.options);
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].value === text || opts[i].textContent.trim() === text) { sel.selectedIndex = i; return true; }
    }
    return false;
  };

  WhatsAppQualifier.prototype.open = function () {
    if (this.state !== 'closed') return;
    this.lastFocused = document.activeElement;
    this.panel.hidden = false;
    if (this.backdrop) this.backdrop.hidden = false;
    // force reflow so transitions run
    void this.panel.offsetHeight;
    this.root.classList.add('is-open');
    this.fab.setAttribute('aria-expanded', 'true');
    this.go('picker');
    var first = this.panel.querySelector('[data-wa-close]');
    if (first) first.focus();
  };

  WhatsAppQualifier.prototype.close = function () {
    if (this.state === 'closed') return;
    // Abandoner capture (US-4): partial flow, contact captured, not handed off.
    this.maybeFireAbandon();
    this.root.classList.remove('is-open');
    this.fab.setAttribute('aria-expanded', 'false');
    var self = this;
    var done = function () {
      self.panel.hidden = true;
      if (self.backdrop) self.backdrop.hidden = true;
      self.panel.removeEventListener('transitionend', done);
    };
    this.panel.addEventListener('transitionend', done);
    // fallback if no transition runs
    window.setTimeout(function () { if (!self.panel.hidden) done(); }, 400);
    this.state = 'closed';
    if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
      try { this.lastFocused.focus(); } catch (e) { /* ignore */ }
    } else {
      this.fab.focus();
    }
  };

  WhatsAppQualifier.prototype.go = function (state) {
    this.state = state;
    Object.keys(this.views).forEach(function (k) { this.views[k].hidden = (k !== state); }, this);

    // body bg: solid white for form + handoff, surface for picker/answer
    if (state === 'form' || state === 'handoff') this.body.classList.add('wa-body--solid');
    else this.body.classList.remove('wa-body--solid');

    this.updateChrome(state);
    // move focus into the newly shown view (first focusable that isn't back btn when sensible)
    var view = this.views[state];
    if (view) {
      var focusTarget = view.querySelector('input, button:not([data-wa-back-picker]):not([data-wa-back-from-form]), a, select');
      if (focusTarget) { try { focusTarget.focus(); } catch (e) {} }
    }
  };

  WhatsAppQualifier.prototype.updateChrome = function (state) {
    var titles = {
      picker: ['How can our engineering team help?', 'Quick answers · or start a quote', 'Step 1 of 3', [0]],
      answer: ['How can our engineering team help?', 'Quick answers · or start a quote', 'Step 1 of 3', [0]],
      form: ['Tell us about your project', 'Takes about 30 seconds', 'Step 2 of 3', ['done', 1]],
      handoff: ["You're set" + (this.firstName ? ', ' + this.firstName : ''), '1 step left · continue on WhatsApp', '1 step left', ['done', 'done', 'active']]
    };
    var t = titles[state] || titles.picker;
    if (this.titleEl) this.titleEl.textContent = t[0];
    if (this.subtitleEl) this.subtitleEl.textContent = t[1];
    if (this.progressLabel) this.progressLabel.textContent = t[2];

    // segments: index → state. picker/answer = seg1 active; form = seg1 done, seg2 active;
    // handoff = seg1+2 done, seg3 active (NOT done — Gate-2 option A: handoff is still an action).
    var segStates;
    if (state === 'form') segStates = ['done', 'active', ''];
    else if (state === 'handoff') segStates = ['done', 'done', 'active'];
    else segStates = ['active', '', ''];
    this.segs.forEach(function (seg, i) {
      seg.classList.remove('is-done', 'is-active');
      if (segStates[i] === 'done') seg.classList.add('is-done');
      else if (segStates[i] === 'active') seg.classList.add('is-active');
    });
    this.progress.classList.toggle('is-done', state === 'handoff');
  };

  WhatsAppQualifier.prototype.showAnswer = function (idx) {
    var faq = this.faqs[idx];
    if (!faq) return;
    this.currentFaqIndex = idx;
    var qEl = this.root.querySelector('[data-wa-answer-q]');
    var aEl = this.root.querySelector('[data-wa-answer-a]');
    if (qEl) {
      qEl.innerHTML = '<span class="wa-faq-pick__ic">' + (ICONS[faq.icon] || ICONS.generic) + '</span>' +
        '<span></span>';
      qEl.lastChild.textContent = faq.question || '';
    }
    if (aEl) aEl.innerHTML = faq.answer || '';
    this.go('answer');
  };

  WhatsAppQualifier.prototype.collect = function () {
    var get = function (name, ctx) {
      var el = ctx.querySelector('[data-wa-input="' + name + '"]');
      return el ? (el.value || '').trim() : '';
    };
    var f = this.form;
    var contact = get('contact', f);
    var data = {
      name: get('name', f),
      contact: contact,
      contact_email: looksLikeEmail(contact) ? contact : '',
      contact_phone: !looksLikeEmail(contact) && looksLikePhone(contact) ? contact : '',
      industry: get('industry', f),
      substrate: get('substrate', f),
      size: get('size', f),
      timeline: get('timeline', f),
      product: get('product', f),
      region: get('region', f) || this.activeRegion
    };
    return data;
  };

  WhatsAppQualifier.prototype.validate = function (data) {
    var ok = true;
    this.setFieldError('name', !data.name);
    if (!data.name) ok = false;
    var contactValid = data.contact && (looksLikeEmail(data.contact) || looksLikePhone(data.contact));
    this.setFieldError('contact', !contactValid);
    if (!contactValid) ok = false;
    return ok;
  };

  WhatsAppQualifier.prototype.setFieldError = function (name, isError) {
    var input = this.root.querySelector('[data-wa-input="' + name + '"]');
    var err = this.root.querySelector('[data-wa-error="' + name + '"]');
    if (input && input.closest) {
      var field = input.closest('.wa-field');
      if (field) field.classList.toggle('has-error', !!isError);
    }
    if (err) err.hidden = !isError;
  };

  WhatsAppQualifier.prototype.handleSubmit = function () {
    var data = this.collect();
    if (!this.validate(data)) {
      var firstErr = this.form.querySelector('.has-error input, .has-error select');
      if (firstErr) firstErr.focus();
      return;
    }

    this.reference = refId();
    this.firstName = (data.name || '').trim().split(/\s+/)[0] || '';
    this.formData = data;
    this.submitted = true;

    // Resolve routed number from region override (or detected market).
    var routeInfo = (this.routes && this.routes[data.region]) || (this.routes && this.routes[this.activeRegion]) || (this.routes && this.routes.GH) || { number: '233256025000', name: 'Ghana' };
    this.routedNumber = routeInfo.number;
    this.routedRegionName = routeInfo.name;

    // Build the WhatsApp message + href BEFORE firing — but FIRE the Klaviyo
    // event (identify + Submitted) BEFORE the user can open the WhatsApp tab.
    var message = this.buildMessage(data, this.reference);
    var href = 'https://wa.me/' + this.routedNumber + '?text=' + encodeURIComponent(message);

    // ===== CRITICAL ORDERING: capture the lead first =====
    fireEvent('quote_qualifier_submitted', {
      reference: this.reference,
      contact_name: data.name,
      contact_email: data.contact_email || undefined,
      contact_phone: data.contact_phone || undefined,
      industry: data.industry,
      substrate: data.substrate,
      project_size: data.size,
      timeline: data.timeline,
      product_interest: data.product,
      region: data.region,
      routed_number: this.routedNumber,
      whatsapp_message: message,
      source_page: window.location.pathname
    });
    // ======================================================

    // Now paint the handoff (the Continue link is the only thing left to do).
    this.renderHandoff(data, href, message);
    this.go('handoff');
  };

  WhatsAppQualifier.prototype.buildMessage = function (data, ref) {
    var parts = [data.industry, data.substrate, data.size, data.timeline].filter(Boolean).join(', ');
    var product = data.product && data.product !== 'General inquiry' ? data.product : 'general inquiry';
    return 'Hi ' + this.businessName + ', this is ' + data.name + '. ' +
      'Reference: ' + ref + '. ' +
      'Project: ' + parts + '. ' +
      'Product interest: ' + product + '.';
  };

  WhatsAppQualifier.prototype.renderHandoff = function (data, href, message) {
    var setText = function (sel, txt, ctx) { var el = ctx.querySelector(sel); if (el) el.textContent = txt; };
    setText('[data-wa-handoff-title]', "You're set" + (this.firstName ? ', ' + this.firstName : ''), this.root);
    setText('[data-wa-ref]', this.reference, this.root);
    setText('[data-wa-msg-preview]', message, this.root);
    setText('[data-wa-region-name]', this.routedRegionName + ' team', this.root);
    setText('[data-wa-region-num]', 'wa.me/' + this.routedNumber, this.root);
    var cont = this.root.querySelector('[data-wa-continue]');
    if (cont) cont.setAttribute('href', href);
  };

  WhatsAppQualifier.prototype.maybeFireAbandon = function () {
    if (this.abandonFired) return;
    if (this.submitted) return; // already captured via Submitted; not an abandon
    // Only fire if the user provided a usable contact in the form.
    if (!this.form) return;
    var contactEl = this.form.querySelector('[data-wa-input="contact"]');
    var nameEl = this.form.querySelector('[data-wa-input="name"]');
    var contact = contactEl ? (contactEl.value || '').trim() : '';
    if (!contact || !(looksLikeEmail(contact) || looksLikePhone(contact))) return;
    var data = this.collect();
    this.abandonFired = true;
    fireEvent('quote_qualifier_abandoned', {
      contact_name: data.name || undefined,
      contact_email: data.contact_email || undefined,
      contact_phone: data.contact_phone || undefined,
      industry: data.industry || undefined,
      substrate: data.substrate || undefined,
      project_size: data.size || undefined,
      timeline: data.timeline || undefined,
      product_interest: data.product || undefined,
      region: data.region || undefined,
      last_step: this.state,
      source_page: window.location.pathname
    });
  };

  WhatsAppQualifier.prototype.trapFocus = function (e) {
    var nodes = Array.prototype.slice.call(this.panel.querySelectorAll(FOCUSABLE))
      .filter(function (n) { return n.offsetParent !== null && !n.disabled; });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('whatsapp-qualifier')).forEach(function (root) {
      if (root.__waInit) return;
      root.__waInit = true;
      try { new WhatsAppQualifier(root); } catch (e) { /* fail silent — feature degrades to nothing */ }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init on Shopify theme editor section load.
  document.addEventListener('shopify:section:load', init);
})();
